<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div class="box" v-else>

      <!-- 头部菜单 -->
      <header>
        <div class="left">
          <img class="log" src="/static/images/logo_white.png" />
          <span class="tit">国家OID煤矸石注册中心</span>
        </div>
        <img class="icon" src="/static/images/anti-fake.png" />
      </header>

      <!-- 内容 -->
      <viewer @inited="inited" ref="viewer">
        <section>

          <!-- 焦点图 -->
            <div class="swiper-container banner" v-if="datas.focus && datas.focus_pics_is_show == 1">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in datas.focus" :key="index"><img :src="item.img"></div>
              </div>
              <div class="swiper-pagination banner-pagination"></div>
            </div>

          <section class="main-box">

            <!-- 企业 -->
            <div class="card-box" v-if="datas.business && datas.business_is_show == 1">
              <div class="nav-one main-text mb40">
                <img class="icon" src="/static/images/Normal01/icon-01.png" />
                <span class="tit">{{ datas.business.name }}</span>
              </div>
              <div class="nav-one mb20">
                <img class="icon" src="/static/images/Normal01/icon-02.png" />
                <span class="tit">{{ datas.business.organization_code }}</span>
              </div>
              <div class="nav-one mb20">
                <img class="icon" src="/static/images/Normal01/icon-03.png" />
                <span class="tit">{{ datas.business.linkphone }}</span>
              </div>
              <div class="nav-one">
                <img class="icon" src="/static/images/Normal01/icon-04.png" />
                <span class="tit">{{ datas.business.baddress }}</span>
              </div>
            </div>

            <!-- 查询输入框 -->
            <div class="card-box" v-if="datas.antifake_is_show && datas.verify">
              <div class="query-box" style="padding-bottom: 0;" v-if="datas.antifake_is_show">
                <input class="inp" v-model="verify" @keyup.enter="InquireFun" placeholder="请在此输入防伪码" />
                <a class="btn" @click="InquireFun">查询</a>
              </div>
            </div>

            <!-- 产品信息 -->
            <div class="card-box" v-if="datas.product && datas.prod_is_show == 1">
              <div class="title">产品信息</div>
              <div class="form">
                <ul class="row" v-if="datas.product.img">
                  <li class="lable">产品图片</li>
                  <li class="value"><img :src="datas.product.img" /></li>
                </ul>
                <ul class="row" v-if="datas.product.productTypeName">
                  <li class="lable">产品类目</li>
                  <li class="value">{{ datas.product.productTypeName }}</li>
                </ul>
                <ul class="row" v-if="datas.product.alias_name">
                  <li class="lable">品牌名称</li>
                  <li class="value">{{ datas.product.alias_name }}</li>
                </ul>
                <ul class="row" v-if="datas.product.name">
                  <li class="lable">产品名称</li>
                  <li class="value">{{ datas.product.name }}</li>
                </ul>
                <ul class="row" v-if="datas.product.unit">
                  <li class="lable">产品规格单位</li>
                  <li class="value">{{ datas.product.unit }}</li>
                </ul>
                <ul class="row" v-if="datas.product.period">
                  <li class="lable">保质期</li>
                  <li class="value">{{ datas.product.period }}</li>
                </ul>
                <template v-if="datas.product.attribute" v-for="val in datas.product.attribute">
                  <ul class="row" v-if="val.key || val.value">
                    <li class="lable">{{ val.key }}</li>
                    <li class="value">
                      <template
                        v-if='val.value && (val.value.substring(val.value.length - 3) === "jpg" || val.value.substring(val.value.length - 3) === "png")'>
                        <img class="img" :src="val.value" />
                      </template>
                      <span v-else>{{ val.value }}</span>
                    </li>
                  </ul>
                </template>
                <ul class="row">
                  <li class="lable">OID认证编号</li>
                  <li class="value">{{ datas.p_idcode }}</li>
                </ul>
              </div>
            </div>

            <!-- 溯源率 -->
            <div class="card-box sy-box" v-if="datas.product.applet_attribute && datas.product.applet_attribute.traceback">
              <div class="title">溯源率</div>
              <div class="top">
                <div class="sy">
                  <p class="tit">整体溯源率</p>
                  <p class="num">{{datas.totalTraceback}}%</p>
                </div>
                <div class="circle circle-main">
                  <div class="circle-box">{{datas.totalTraceback}}%</div>
                </div>
              </div>
              <div class="bottom mt35" :style="{'justify-content': datas.product.applet_attribute.traceback.length < 4?'space-around':''}">

                <div class="row" v-for="(item, index) in datas.product.applet_attribute.traceback" :key="index">
                  <div class="circle">
                    <div class="circle-box">{{item.value}}{{item.value.includes('%')?'':'%'}}</div>
                  </div>
                  <div class="circle-tit mt20">{{item.key}}</div>
                </div>

              </div>
            </div>

            <!-- 产品成分 -->
            <div class="card-box" v-if="datas.product.applet_attribute && ((datas.product.applet_attribute.nutrition && Object.keys(datas.product.applet_attribute.nutrition).length) || (datas.product.applet_attribute.material && Object.keys(datas.product.applet_attribute.material).length))">
              <div class="title">产品成分</div>
              
              <!-- 商品营养表 -->
              <template v-if="datas.product.applet_attribute.nutrition && Object.keys(datas.product.applet_attribute.material).length">
                <div class="subtitle">
                  <img class="icon" src="/static/images/Normal01/icon-05.png" />
                  <span class="tit">商品营养表</span>
                </div>
                <div class="table mt30">
                  <ul class="table-head">
                    <li>项目</li>
                    <li>每100g</li>
                    <li>NRV%</li>
                  </ul>
                  <ul class="table-body" v-for="(value, index) in datas.product.applet_attribute.nutrition" :key="index">
                    <li>{{value.key}}</li>
                    <li>{{value.value}}</li>
                    <li>{{value.ratio}}</li>
                  </ul>
                </div>
              </template>

              <!-- 主要原料 -->
              <template v-if="datas.product.applet_attribute.material && Object.keys(datas.product.applet_attribute.material).length">
                <div class="subtitle mt40" style="border: none;">
                  <img class="icon" src="/static/images/Normal01/icon-06.png" />
                  <span class="tit">主要原料</span>
                </div>
                <div class="form">
                  <ul class="row" v-for="(value, index) in datas.product.applet_attribute.material" :key="index">
                    <li class="lable">{{value.key}}</li>
                    <li class="value">{{value.value}}</li>
                  </ul>
                </div>
              </template>

            </div>

            <!-- 企业资质 -->
            <div class="card-box" v-if="datas.business.customize_data && datas.business.customize_data.qualification && datas.business.customize_data.qualification.length">
              <div class="title">企业资质</div>
              <div class="swiper-container qualification" :style="{height: datas.business.customize_data.qualification.length > 3?'280rem':''}">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, index) in datas.business.customize_data.qualification" :key="index"><img :src="item.value"></div>
                </div>
                <div class="qualification-pagination" v-if="datas.business.customize_data.qualification.length > 3"></div>
              </div>
            </div>


            <div class="card-box" v-if="records.length">
              <div class="title">查询记录</div>
              <div class="nav-two">
                <span class="lable">查询次数</span>
                <span class="value">{{ datas.scan_count }}</span>
              </div>
              <div class="nav-two mt20">
                <span class="lable">首次查询时间</span>
                <span class="value">{{ datas.scan_first_time }}</span>
              </div>

              <div class="line">
                <ul class="row" v-for="(item, index) in records" :key="index">
                  <li class="tit">{{item.created_at}}</li>
                  <li class="txt">来自 {{item.ip}} 的查询</li>
                </ul>
              </div>
            </div>
          </section>


          <div class="copyright">
            <div class="tit">©国家OID煤矸石注册中心</div>
            <div class="txt">所有信息真实性由生产方全程披露为信息负法律责任</div>
          </div>

        </section>
      </viewer>

      <!-- 弹出框 -->
      <K-AlertMsg :AlertMsg="AlertMsg" @AlertBack="AlertBack" bg="#08AD77" top="25vh"></K-AlertMsg>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import AlertMsg from '@/components/AlertMsg.vue'
import Loading from '@/components/Loading.vue'
import Speaker from '../hook/auto.js'
import mixin from '../mixins/mixin.js'
export default {
  name: 'Normal01',
  components: {
    'K-Loading': Loading,
    'K-AlertMsg': AlertMsg,
  },
  mixins: [mixin],
  data() {
    return {
      records: [],
      queryLoading: false,
      queryContent: null,
    }
  },
  created() {
    this.AdaptiveSizeNew();
    document.querySelector('body').setAttribute('style', 'background-color:#E9F4EF');

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      const pid = this.$route.query.pid; //产品ID
      const rid = this.$route.query.rid; //企业ID
      this.GetDemoDatas(pid, rid);  //获取演示模板信息
    } else {
      this.GetDatas(()=>{
        this.loaded();
      });  //获取码标信息
      // this.GetRecord(); //扫码记录
      
    }
  },
  methods: {
    loaded(){
      setTimeout(() => {
        new Swiper('.banner', {
          autoplay: {
            delay: 5000,
            disableOnInteraction: false, // 手动滑动后继续自动播放
          },
          loop: true,
          pagination: {
            el: ".banner-pagination",
            clickable: true,
          }
        })

        new Swiper('.qualification', {
          slidesPerView : 3,
          spaceBetween : 10,
          pagination: {
            el: ".qualification-pagination",
            clickable: true,
          }
        })
      });
    },
    GetRecord () {
      axios.get(this.GetServerUrl(1)+"queryList/" + this.code+ "/1")
      .then((response)=>{
        let datas = response.data.meta.data;
        if(datas.length){
          this.records = datas.slice(0,5);
          console.log(this.records)
        }
      }).catch((error)=>{
        console.log(error)
      })
    },
    InquireFun() {
      let msg;
      if(!this.verify){
        msg = '请输入验证码！';
      }else if(![6, 12].includes(this.verify.length)){
        msg = '验证码不正确！';
      }
      if(msg){
        this.AlertMsg.msg = msg;
        this.AlertMsg.state = true;
        return;
      }
      this.queryContent = null;
      this.queryLoading = true;
      this.CodeVerify(axios, (e) => {
        this.queryLoading = false;
        this.queryContent = e.data.meta;
        if (this.queryContent.query_count > 1) {
          msg = this.datas.many_antifake_msg?this.datas.many_antifake_msg:"您查询的码标已经被多次扫描，谨防假冒!";
        }
        if (this.queryContent.query_count <= 1) {
          msg = this.datas.first_antifake_msg?this.datas.first_antifake_msg:`您查询的是 ${this.datas.business.name} 的正牌产品，请您放心使用!`;
        }
        this.AlertMsg.msg = msg;
        this.AlertMsg.state = true;
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../static/css/common.scss';

@font-face {
  font-family: 'PFRegular';
  src: url('https://file.oid.plus/website/fonts/PF-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  /* 优化字体加载显示 */
}

@font-face {
  font-family: 'PFBold';
  src: url('https://file.oid.plus/website/fonts/PF-bold.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  /* 优化字体加载显示 */
}

$themeColor: #08AD77;
$fontColor: #50585D;
$borderColor: #F6F6F6;

* {
  padding: 0;
  margin: 0;
  list-style: none;
  font-size: 28rem;
  color: $fontColor;
  outline: none !important;
  font-family: PFRegular, "微軟正黑體", sans-serif;
}

img {
  display: block;
}

header {
  height: 110rem;
  padding: 0 20rem;
  background-color: $themeColor;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    gap: 20rem;
    display: flex;
    align-items: center;
    flex-direction: row;

    .log {
      width: 75rem;
      height: 50rem;
    }

    .tit {
      color: white;
      font-size: 36rem;
      font-family: PFBold;
    }
  }

  .icon {
    width: 30rem;
  }
}

.banner {
  img {
    width: 100%;
    height: 330rem;
    object-fit: cover;
  }
  .banner-pagination{
    position: absolute;
    z-index: 9;
    display: flex;
    justify-content: center;
  }
}

.main-box {
  padding: 20rem;
}

.card-box {
  padding: 30rem;
  border-radius: 20rem;
  background-color: white;
  margin-bottom: 20rem;
}

.title {
  line-height: 1;
  font-size: 34rem;
  padding-bottom: 40rem;
  color: $themeColor;
  font-family: PFBold;
}

.nav-one {
  gap: 20rem;
  display: flex;
  align-items: center;
  flex-direction: row;

  .icon {
    width: 30rem;
    height: 30rem;
  }

  .tit {
    font-size: 28rem;
    line-height: 1.2;
  }
}

.main-text {
  .icon {
    width: 35rem;
    height: 35rem;
  }

  .tit {
    font-size: 34rem;
    color: $themeColor;
    font-family: PFBold;
  }
}


.form {
  .row {
    display: flex;
    padding: 20rem 0;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid $borderColor;

    .lable {
      min-width: 180rem;
    }

    .value {
      color: black;
      span{
        color: black;
      }

      img {
        width: 160rem;
        height: 160rem;
        border-radius: 20rem;
        object-fit: cover;
      }
    }
  }
}

//溯源率
.sy-box {
  .sy {
    .num {
      font-size: 45rem;
      color: $themeColor;
      font-family: Arial, Helvetica, sans-serif;
      font-weight: bold;
    }
  }

  .top {
    display: flex;
    justify-content: space-between;
  }

  .bottom {
    gap: 30rem;
    display: flex;
    overflow-x: auto;
    text-align: center;

    .row:nth-child(1) .circle-box {
      background-image: linear-gradient(to right, #46b25d, #48b15d);
    }

    .row:nth-child(2) .circle-box {
      background-image: linear-gradient(to right, #48de84, #50dd81);
    }

    .row:nth-child(3) .circle-box {
      background-image: linear-gradient(to right, #f8c221, #f9c126);
    }

    .row:nth-child(4) .circle-box {
      background-image: linear-gradient(to right, #f59e0b, #f59e0b);
    }
  }

  .circle {
    background-color: #eef7ff;
    border-radius: 200rem;
    padding: 15rem;
    width: 110rem;
    height: 110rem;

    .circle-box {
      width: 100%;
      height: 100%;
      color: white;
      display: flex;
      font-family: Arial, Helvetica, sans-serif;
      font-weight: bold;
      align-items: center;
      justify-content: center;
      border-radius: 200rem;
      background-image: linear-gradient(to right, #46b065, #3f60a5 80%);
    }
  }

  .circle-main {
    width: 185rem;
    height: 185rem;

    .circle-box {
      width: 100%;
      height: 100%;
      font-size: 45rem;
    }
  }
}

//产品成分
.subtitle {
  gap: 15rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  border-bottom: 1px solid $borderColor;
  padding-bottom: 30rem;

  .icon {
    width: 35rem;
    height: 35rem;
  }

  .tit {
    color: black;
    font-size: 30rem;
  }
}

.table {
  .table-head {
    display: flex;
    flex-direction: row;
    align-items: center;

    li {
      flex: 1;
      color: black;
      padding: 20rem 0;
      background-color: #edf6fd;
      &:not(:first-child){
        text-align: center;
      }
      &:first-child{
        padding-left: 40rem;
      }
    }
  }

  .table-body {
    display: flex;
    flex-direction: row;
    align-items: center;

    li {
      flex: 1;
      padding: 20rem 0;
      border-bottom: 1px solid $borderColor;
      &:not(:first-child){
        text-align: center;
      }
      &:first-child{
        padding-left: 40rem;
      }
    }
  }
}

.qualification{
  img{
    width: 100%;
    border-radius: 10rem;
    box-sizing: border-box;
    height: 200rem;
    object-fit: cover;
    border: 1px solid $borderColor;
  }
}

//查询记录
.nav-two{
  padding: 30rem;
  border-radius: 15rem;
  border: 1px solid $borderColor;
  background-color: #E9F4EF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .value{
    color: black;
  }
}
.line{
  .row{
    padding: 30rem 0;
    padding-left: 70rem;
    position: relative;
    &:not(:last-child){
      border-bottom: 1px dashed #EEE;
    }
    &::before{
      display: block;
      content: '';
      width: 16rem;
      height: 16rem;
      border-radius: 16rem;
      position: absolute;
      left: 35rem;
      transform: translateY(6rem);
      background-color: $themeColor;
    }
    .tit{
      color: black;
      line-height: 1;
    }
    .txt{
      line-height: 1;
      margin-top: 20rem;
    }
  }
}


//版权
.copyright{
  padding-top: 10rem;
  padding-bottom: 80rem;
  text-align: center;
  line-height: 1;
  .tit{
    font-size: 26rem;
    letter-spacing: 2rem;
  }
  .txt{
    font-size: 24rem;
    color: #A1A1A1;
    margin-top: 12rem;
  }
}

.query-box{
  font-size: 30rem;
  word-wrap: break-word;
  position: relative;

  .inp {
    border-radius: 3px;
    padding: 0 70px 0 10px;
    height: 45px;
    width: 100%;
    font-size: 16px;
    box-sizing: border-box;
    border: 2px solid $themeColor;
  }

  .btn {
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    width: 60px;
    line-height: 45px;
    display: table;
    background-color: $themeColor;
    text-align: center;
    color: #FFF;
    z-index: 99;
    border-radius: 0 3px 3px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Normal01.vue